import { Course, CourseCategory } from "@interfaces/course"
import { PaginationData } from "@interfaces/misc"
import CourseRepositories from "../repositories/course.repositories"
import { Result } from "@services/result"

export default class CourseServices extends CourseRepositories {
  async getCourseList(query: any) {
    try {
      const res = await this.getRawCourses(query)

      const response = await this._getResponse<PaginationData<Course>>(res)

      if (response.error) {
        return Result.fail<PaginationData<Course>>()
      }

      const result = response.result

      if (result) {
        return Result.ok<PaginationData<Course>>(result)
      } else {
        return Result.ok<PaginationData<Course>>({
          data: [],
          currentPage: 1,
          totalData: 0,
          totalPage: 1,
          current_page: 1,
          total_data: 0,
        })
      }
    } catch (e) {
      return Result.fail<PaginationData<Course>>()
    }
  }

  async getCategoryList() {
    try {
      const res = await this.getRawCategories()

      const response = await this._getResponse<CourseCategory[]>(res)

      if (response.error || !response.result) {
        return Result.fail<CourseCategory[]>()
      }

      return Result.ok<CourseCategory[]>(response.result)
    } catch (e) {
      return Result.fail<CourseCategory[]>()
    }
  }
}
